// Dependency import
import { GetUTMParams }            from "../_get-utm-params";
import { ZerobounceValidateEmail } from "../_zerobounce-validate-email";

// Elements
const FORM_WRAPPER = ".js-form-wrapper";
const FORM = ".js-form-get-a-quote";
const THANK_YOU = ".js-thank-you";
const STEP1 = ".js-form-step1";
const STEP2 = ".js-form-step2";
const FORM_ITEM = ".form-item";
const ANCHOR_STEP1 = ".js-anchor-step1";
const ANCHOR_STEP2 = ".js-anchor-step2";
const SUBMIT = ".js-form-sumit-btn";
const STEPS_PRELOADER = ".js-steps-preloader";
const LOADING_CLASS_NAME = "is-loading";
const DISABLED_CLASS_NAME = "is-disabled";
const POSITION = ".js-position";
const ORGANIZATION = ".js-organization";
const STATE = ".js-state";
const COUNTRY = ".js-country";
const TRANSPARENT_ON_THANK_YOU = ".js-transparent-on-thank-you";

// Validation options
const VALIDATION_OPTIONS_STEP1 = {
	fields: {
		"firstname": {
			validators: {
				notEmpty: {
					message: "Please enter your first name"
				},
				stringLength: {
					min: 2,
					max: 20,
					message: "The first name must be between 2 and 20 characters long"
				}
			}
		},
		"lastname": {
			validators: {
				notEmpty: {
					message: "Please enter your last name"
				},
				stringLength: {
					min: 2,
					max: 20,
					message: "The last name must be between 2 and 20 characters long"
				}
			}
		},
		"country": {
			validators: {
				notEmpty: {
					message: "Please select your country"
				}
			}
		},
		"state": {
			validators: {
				notEmpty: {
					message: "Please select your state"
				}
			}
		},
		"district": {
			validators: {
				notEmpty: {
					message: "Please select your district"
				}
			}
		},
		"email": {
			validators: {
				notEmpty: {
					message: "Please enter your email address"
				},
				emailAddress: {
					message: "Your email address should look like that John@example.com"
				},
                remote: {
                    message: "The email is invalid. Please check"
                }
			}
		},
		"phone": {
			validators: {
				numeric: {
					message: "The phone number must contain only numbers"
				},
				notEmpty: {
					message: "Please enter your phone number"
				},
				stringLength: {
					min: 7,
					max: 20,
					message: "The phone number must be between 7 and 20 characters long"
				},
                remote: {
                    message: "Please enter another phone number"
                }
			}
		},
		"position": {
			validators: {
				notEmpty: {
					message: "Please select the option that best applies"
				}
			}
		},
	},
    plugins: {
        message: new FormValidation.plugins.Message({
            clazz: 'form-error',
            container: function(field, element) {
                return element.closest( ".form-item" );
            }
        }),
        trigger: new FormValidation.plugins.Trigger(),
    }
};

const VALIDATION_OPTIONS_STEP2 = {
	fields: {
		"grade": {
			validators: {
				choice: {
					min: 1,
					message: "Please select at least one of students' age"
				}
			}
		},
		"number_students_1": {
			validators: {
				notEmpty: {
					message: "Please select the course"
				},
				numeric: {
					message: "Please select estimated number of students"
				}
			}
		},
		"number_students_2": {
			validators: {
				notEmpty: {
					message: "Please select the course"
				},
				numeric: {
					message: "Please select estimated number of students"
				}
			}
		},
		"number_students_3": {
			validators: {
				notEmpty: {
					message: "Please select the course"
				},
				numeric: {
					message: "Please select estimated number of students"
				}
			}
		},
		"number_students_4": {
			validators: {
				notEmpty: {
					message: "Please select the course"
				},
				numeric: {
					message: "Please select estimated number of students"
				}
			}
		},
		"number_students_5": {
			validators: {
				notEmpty: {
					message: "Please select the course"
				},
				numeric: {
					message: "Please select estimated number of students"
				}
			}
		},
		"number_students_6": {
			validators: {
				notEmpty: {
					message: "Please select the course"
				},
				numeric: {
					message: "Please select estimated number of students"
				}
			}
		},
		"number_students_7": {
			validators: {
				notEmpty: {
					message: "Please select the course"
				},
				numeric: {
					message: "Please select estimated number of students"
				}
			}
		},
		"number_students_texas": {
			validators: {
				notEmpty: {
					message: "Please select the course"
				},
				numeric: {
					message: "Please select estimated number of students"
				}
			}
		},
		"course_name": {
			validators: {
				notEmpty: {
					message: "Please select the course"
				}
			}
		}
	},
    plugins: {
        message: new FormValidation.plugins.Message({
            clazz: 'form-error',
            container: function(field, element) {
                return element.closest( ".form-item" );
            }
        }),
        trigger: new FormValidation.plugins.Trigger(),
    }
};

const POSITIONS_FOR_ORGANIZATION = [ "Teacher", "Principle", "District Administrator" ];

// Formhandler
function quoteForm() {
	
	if ( document.querySelector( FORM ) != null ) {

		let zero_bounce_status = "";
		let currentStep = 1;

		$( STEPS_PRELOADER ).removeClass( LOADING_CLASS_NAME );

		const step1 = document.querySelector( STEP1 );
        const anchorstep1 = document.querySelector( ANCHOR_STEP1 );
        const anchorstep2 = document.querySelector( ANCHOR_STEP2 );
        const fv1 = FormValidation
        .formValidation(
            step1,
            VALIDATION_OPTIONS_STEP1
        )
        .on('core.form.valid', function() {

	        $( STEPS_PRELOADER ).addClass( LOADING_CLASS_NAME );

			// ZeroBounce API check
	        ZerobounceValidateEmail( FORM + " input[name='email']", function ( response ) {
		        zero_bounce_status = response.status;

		        if ( response.status === "invalid" ) {
			        fv1.updateFieldStatus( "email", "Invalid", "remote" );
			        $( STEPS_PRELOADER ).removeClass( LOADING_CLASS_NAME );

			        const getaquoteformerror = new CustomEvent( "getaquoteformerror", {
				        detail: {
					        step: 1
				        }
			        } );
			        document.dispatchEvent( getaquoteformerror );
		        } else {

			        currentStep++;
			        FormValidation.utils.classSet( step1, {
				        "is-form-hidden": true
			        } );
			        FormValidation.utils.classSet( step2, {
				        "is-form-hidden": false
			        } );
			        FormValidation.utils.classSet( anchorstep1, {
				        "opacity-70": true
			        } );
			        FormValidation.utils.classSet( anchorstep2, {
				        "opacity-70": false
			        } );
			        FormValidation.utils.classSet( anchorstep1, {
				        "cursor-pointer": true
			        } );
			        FormValidation.utils.classSet( anchorstep2, {
				        "cursor-pointer": false
			        } );

			        $( STEPS_PRELOADER ).removeClass( LOADING_CLASS_NAME );

			        const getaquoteformnextstep = new CustomEvent( "getaquoteformnextstep" );
			        document.dispatchEvent( getaquoteformnextstep );
		        }
            });
        });
        fv1.disableValidator( "email", "remote" );
        fv1.disableValidator( "phone", "remote" );

		const step2 = document.querySelector( STEP2 );

        const fv2 = FormValidation
        .formValidation(
            step2,
            VALIDATION_OPTIONS_STEP2
        )
        .on('core.form.valid', function() {

	        $( STEPS_PRELOADER ).addClass( LOADING_CLASS_NAME );

        	let data = "?" + $( FORM ).serialize();

			// Add UTM parameters from string
            data += GetUTMParams();

        	// make obj from data
        	let urlParams = new URLSearchParams( data );

        	let unserializedData = {};
        	for ( let [ key, value ] of urlParams ) {
        		if ( unserializedData.hasOwnProperty( key ) ) {
        			unserializedData[ key ] += ", " + value;
        		} else {
        			unserializedData[ key ] = value;
        		}
        	}

        	// change country and state to correct values
        	unserializedData.country =
        		document.getElementById( "country" ).selectedOptions[ 0 ].textContent;

        	if ( document.getElementById( "state" ).selectedOptions[ 0 ].textContent.toLowerCase() ==
        	     "other" ) {
        		unserializedData.state = "";
        	} else {
        		unserializedData.state =
        			document.getElementById( "state" ).selectedOptions[ 0 ].textContent;
        	}

			unserializedData.district =
        		document.getElementById( "district" ).selectedOptions[ 0 ].textContent;

	        unserializedData.zero_bounce_status = zero_bounce_status;

        	jQuery.ajax( {
        		url: gocoderzAjax.url,
        		type: "post",
        		data: {
        			action: "hubspot_get_a_quote_submit",
        			nonce: gocoderzAjax.nonce,
        			formData: unserializedData
        		},
        		success: function ( response ) {
        			if ( response == "success" ) {
                       // $( FORM_WRAPPER ).hide();
                        $( TRANSPARENT_ON_THANK_YOU ).css( "opacity", "0" );
                        // $( THANK_YOU ).show();

						$( STEPS_PRELOADER ).addClass( LOADING_CLASS_NAME );
						window.location.href = '/thank-you-well-be-in-touch-soon/';

				        const getaquoteformsubmitted = new CustomEvent( "getaquoteformsubmitted", {
					        detail: {
						        formData: unserializedData
					        }
				        } );
				        document.dispatchEvent( getaquoteformsubmitted );
                    } else if ( response == "INVALID_EMAIL" ) {
                        currentStep--;
                        FormValidation.utils.classSet(step1, {
                            "is-form-hidden": false,
                        });
                        FormValidation.utils.classSet(step2, {
                            "is-form-hidden": true,
                        });
                        FormValidation.utils.classSet(anchorstep1, {
                            "opacity-70": false,
                        });
                        FormValidation.utils.classSet(anchorstep2, {
                            "opacity-70": true,
                        });
                        FormValidation.utils.classSet(anchorstep1, {
                            "cursor-pointer": false,
                        });
                        FormValidation.utils.classSet(anchorstep2, {
                            "cursor-pointer": true,
                        });
                        fv1.updateFieldStatus( "email", "Invalid", "remote" );

				        const getaquoteformerror = new CustomEvent( "getaquoteformerror", {
					        detail: {
						        step: 2
					        }
				        } );
				        document.dispatchEvent( getaquoteformerror );
                    } else if ( response == "NUMBER_OUT_OF_RANGE" ) {
                        currentStep--;
                        FormValidation.utils.classSet(step1, {
                            "is-form-hidden": false,
                        });
                        FormValidation.utils.classSet(step2, {
                            "is-form-hidden": true,
                        });
                        FormValidation.utils.classSet(anchorstep1, {
                            "opacity-70": false,
                        });
                        FormValidation.utils.classSet(anchorstep2, {
                            "opacity-70": true,
                        });
                        FormValidation.utils.classSet(anchorstep1, {
                            "cursor-pointer": false,
                        });
                        FormValidation.utils.classSet(anchorstep2, {
                            "cursor-pointer": true,
                        });
                        fv1.updateFieldStatus( "phone_number", "Invalid", "remote" );

				        const getaquoteformerror = new CustomEvent( "getaquoteformerror", {
					        detail: {
						        step: 2
					        }
				        } );
				        document.dispatchEvent( getaquoteformerror );
        			} else {

				        const getaquoteformerror = new CustomEvent( "getaquoteformerror", {
					        detail: {
						        step: 2
					        }
				        } );
				        document.dispatchEvent( getaquoteformerror );
                        console.error( "Error:", error );
        			}
                    //$( STEPS_PRELOADER ).removeClass( LOADING_CLASS_NAME );
        		},
        		error: function ( error ) {
                    $( STEPS_PRELOADER ).removeClass( LOADING_CLASS_NAME );
                    console.error( "Error:", error );

			        const getaquoteformerror = new CustomEvent( "getaquoteformerror", {
				        detail: {
					        step: 2
				        }
			        } );
			        document.dispatchEvent( getaquoteformerror );
        		}
        	} );
        });

        $( ANCHOR_STEP2 ).on("click", function () {
            fv1.validate();
        })

        $( ANCHOR_STEP1 ).on("click", function () {
            currentStep--;
            FormValidation.utils.classSet(step1, {
                "is-form-hidden": false,
            });
            FormValidation.utils.classSet(step2, {
                "is-form-hidden": true,
            });
            FormValidation.utils.classSet(anchorstep1, {
                "opacity-70": false,
            });
            FormValidation.utils.classSet(anchorstep2, {
                "opacity-70": true,
            });
            FormValidation.utils.classSet(anchorstep1, {
                "cursor-pointer": false,
            });
            FormValidation.utils.classSet(anchorstep2, {
                "cursor-pointer": true,
            });
        });

        $( SUBMIT ).on("click", function ( event ) {
            event.preventDefault();

			$('.js-course-info').each( function(){
				var isChecked  = $(this).find('input[type="checkbox"]').is(':checked');
				var inputName  = $(this).find('input[name^="number_students_"]').attr('name');
				var inputValue = $(this).find('input[name^="number_students_"]').val();

				if( !isChecked ) {
					fv2.disableValidator( inputName );
				} else {
					fv2.enableValidator( inputName );

					if ( inputValue > 0 && inputValue < 30 ) {
						$.fancybox.open($("#popup-get-a-quote"), {
							touch: false,
							mobile: {
								touch: true
							}
						});

						return false;
					}
				}
			});

            fv2.validate();

        });
		
		$( POSITION ).on( "change", function () {
            fv1.validateField( "position" );
		} );

		// $( POSITION ).on( "change", function () {
        //     fv1.validateField( "position" );
		// 	if ( POSITIONS_FOR_ORGANIZATION.includes( this.value ) ) {
		// 		$( ORGANIZATION ).removeClass( DISABLED_CLASS_NAME );
		// 		fv2.enableValidator( "company" );
        //         $( ORGANIZATION + " input" ).prop( "disabled", false );
		// 	} else {
        //         $( ORGANIZATION ).addClass( DISABLED_CLASS_NAME );
		// 		fv2.disableValidator( "company" );
		// 		$( ORGANIZATION + " input" ).val( "" );
        //         $( ORGANIZATION + " input" ).prop( "disabled", true );
		// 	}
		// } );

		$( STATE ).on( "change", function ( e ) {
            fv1.validateField( "state" );
			
			if ( $(this).val() === 'TX' ) {
				$( '.js-course-texas' ).show();
			} else {
				$( '.js-course-texas' ).hide();
			}
        } );

		$( STATE ).on( "select2:select", function ( e ) {
			if ( "OTHER" === e.target.value ) {
                fv1.disableValidator( "state" );
			}
		} );

		$( COUNTRY ).on( "change", function ( e ) {
            fv1.validateField( "country" );
        } );

		$( COUNTRY ).on( "select2:select", function ( e ) {
			let $parentStateFormItem = $( STATE ).parent( FORM_ITEM );
			if ( "US" === e.target.value ) {
				$parentStateFormItem.removeClass( DISABLED_CLASS_NAME );
			} else {
				$parentStateFormItem.addClass( DISABLED_CLASS_NAME );
			}
		} );

		// Listen for changes in the checkbox
		$(".form-alt-checkbox-input").change(function() {
			const courseInfo = $(this).closest(".js-course-info");
			const inputArea = courseInfo.find(".js-course-info-input");
		
			if ($(this).prop("checked")) {
				inputArea.slideDown();
			} else {
				inputArea.slideUp();
			}
		});
	}
}

export { quoteForm };
